<template src="./CreateSettingFormatFileComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {AppConstant} from "@/supports/app.constant";
import {ref, computed, onMounted, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {ErrorText} from "@/supports/error-message.constant.ts";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import {useRouter, useRoute} from "vue-router";
import draggable from 'vuedraggable';
import DragNormalComponent from "@/components/draggable/drag-normal/DragNormalComponent.vue";
import {useSettingFormatFileStore} from "@/stores/settingFormatFile.js";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import {useAccountStore} from "@/stores/account.js";
import ErrorMessageService from "@/services/error-message.service.ts";

export default {
  name: 'CreateSettingFormatFileComponent',
  components: {
    InputCheckboxOne,
    DragNormalComponent,
    InputTextareaNormal,
    ButtonAddComponent,
    draggable,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const errors = ref([])
    const mode = ref('create')
    const labelButtonSetting = ref('Tạo cài đặt')
    const settingId = ref(null)
    const dataSettingFile = ref({
      name: {
        id: 'name',
        label: 'Tên cài đặt',
        placeholder: 'Tên cài đặt',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      table_use: {
        id: 'table_use',
        label: 'Nơi sử dụng',
        placeholder: 'Nơi sử dụng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: [
          {
            name: 'Sản phẩm',
            value: 'product'
          },
          {
            name: 'Đối tác',
            value: 'partner'
          },
        ]
      },
      type: {
        id: 'type',
        label: 'Kiểu file',
        placeholder: 'Kiểu file',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: [
          {
            name: 'Excel (.xlsx, .xls)',
            value: '1'
          },
          {
            name: 'CSV (.csv)',
            value: '2'
          },
        ]
      },
      description: {
        id: 'description',
        label: 'Mô tả',
        placeholder: 'Mô tả',
        value: '',
        error: '',
        isError: false,
        required: false
      },
      fields: {
        id: 'fields',
        label: 'Danh sách cột tuỳ chỉnh',
        value: {},
        error: '',
        isError: false,
        required: true
      },
    })
    const fieldsCustom = ref({})
    const errorMessage = ref([])
    const router = useRouter()
    const route = useRoute()
    const listItemSelected = ref([])
    const checkItems = ref({})
    const settingFormatFileDetail = ref(null)
    const checkAll = ref(false)
    const settingFormatFileStore = useSettingFormatFileStore();
    const accountStore = useAccountStore()

    onMounted(() => {
      settingId.value = route.params.id;
      mode.value = route.params.mode;
      if(mode.value === 'detail') {
        labelButtonSetting.value = 'Cập nhập cài đặt';
        getDataSettingFileDetail()
      }
    });

    watch(() => settingFormatFileStore.settingFormat, (newSettingFormatFiles) => {
      settingFormatFileDetail.value = newSettingFormatFiles;
      if(settingFormatFileDetail.value) {
        dataSettingFile.value.name.value = settingFormatFileDetail.value.name;
        dataSettingFile.value.type.value = settingFormatFileDetail.value.type;
        dataSettingFile.value.table_use.value = settingFormatFileDetail.value.table_use;
        dataSettingFile.value.description.value = settingFormatFileDetail.value.description;
      }
    });

    watch(() => settingFormatFileStore.fields, (newFields) => {
      const usedKeys = new Set();
      for (const [key, field] of Object.entries(newFields)) {
        checkItems.value[key] ??= false;
        if (dataSettingFile.value.table_use.value === 'product') {
          if (['warehouse_code', 'warehouse_id'].includes(key)) {
            checkItems.value[key] = true;
            usedKeys.add(key);
            fieldsCustom.value[key] = field;
          }
        }
      }
      if (mode.value === 'detail' && settingFormatFileDetail.value.formatFileDetail) {
        settingFormatFileDetail.value.formatFileDetail.forEach((item) => {
          usedKeys.add(item.field);
          checkItems.value[item.field] = true
          fieldsCustom.value[item.field] = item.field_name
        });
      }
      listItemSelected.value = Array.from(usedKeys);
      if(listItemSelected.value.length === Object.keys(settingFormatFileStore.fields).length) {
        checkAll.value = true;
      }
    }, { immediate: true });

    watch(() => dataSettingFile.value.table_use.value, (newTableUse) => {
      resetFieldsWithTableUse();
      getListFields(newTableUse);
    });

    function resetFieldsWithTableUse() {
      fieldsCustom.value = {}
      settingFormatFileStore.fields = [];
      listItemSelected.value = [];
      checkAll.value = false;
      checkItems.value = {}
    }

    const fields = computed({
      get: () => settingFormatFileStore.fields,
      set: (val) => settingFormatFileStore.fields = val
    });
    function getListFields(location) {
      const params = {}
      switch (location) {
        case 'product':
          params.location_use = 1
          break;
        case 'partner':
          params.location_use = 2
          break;
      }
      const url = AppConstant.URL_API_LOCAL + 'api/format-file/field-list';
      settingFormatFileStore.getListField(url, params);
    }

    function onChangeSelectItem(value, name) {
      checkItems.value[name] = value
      let counterChecked = 0
      for (const [key, field] of Object.entries(fields.value)) {
        if(checkItems.value[key]) {
          counterChecked++
        }
        if(value && listItemSelected.value.indexOf(key) === -1 && name === key) {
          fieldsCustom.value[key] = field
          listItemSelected.value.push(key)
        }else if (!value && listItemSelected.value.indexOf(key) !== -1 && name === key) {
          delete fieldsCustom.value[key]
          listItemSelected.value.splice(listItemSelected.value.indexOf(key), 1);
        }
      }
      checkAll.value = false
      if(counterChecked === Object.keys(checkItems.value).length) {
        checkAll.value = true
      }
    }

    function onChangeSelectAll(value) {
      checkAll.value = value
      for (const key in checkItems.value) {
        checkItems.value[key] = value
      }
      if(!value) {
        listItemSelected.value = []
        fieldsCustom.value = {}
      }else {
        for (const [key, field] of Object.entries(fields.value)) {
          if(listItemSelected.value[key] === undefined) {
            listItemSelected.value.push(key)
            fieldsCustom.value[key] = field
          }
        }
      }
    }

    async function createSettingFile() {
      dataSettingFile.value.fields.value = fieldsCustom.value
      for (const item in dataSettingFile.value) {
        validateForm(dataSettingFile.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        const params = {
          id: settingFormatFileStore.settingFormat.id,
          company_id: accountStore.account.company.id,
          name: dataSettingFile.value.name.value,
          table_use: dataSettingFile.value.table_use.value,
          type: dataSettingFile.value.type.value,
          description: dataSettingFile.value.description.value,
          fields: prepareFields(dataSettingFile.value.fields.value),
        }
        let url = AppConstant.URL_API_LOCAL + 'api/format-file/create';
        if(mode.value === 'detail') {
          url = AppConstant.URL_API_LOCAL + 'api/format-file/update';
        }
        const setting = await settingFormatFileStore.createOrUpdateSettingFile(url, params);
        errorMessage.value = await ErrorMessageService.getErrorMessage(setting)
        if(errorMessage.value === undefined || (typeof errorMessage.value === 'array' && errorMessage.value.length === 0)) {
          await CommonService.showAlertPopup({
            title: setting?.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1000,
            width: '800px'
          });

          await router.push('/setting/format-file')
        }
      }
    }
    function onChange(value, name) {
      dataSettingFile.value[name].value = value
    }
    function validateForm(value, name) {
      if(name === 'name') {
        dataSettingFile.value.name.isError = false;
        dataSettingFile.value.name.error = ''
        errors.value['name'] = false
        if(value.trim() === "") {
          dataSettingFile.value.name.isError = true;
          dataSettingFile.value.name.error = ErrorText.REQUIRED(dataSettingFile.value.name.label);
          errors.value['name'] = true
        }
      }
      if(name === 'table_use') {
        dataSettingFile.value.table_use.isError = false;
        dataSettingFile.value.table_use.error = ''
        errors.value['table_use'] = false
        if(!value) {
          dataSettingFile.value.table_use.isError = true;
          dataSettingFile.value.table_use.error = ErrorText.REQUIRED(dataSettingFile.value.table_use.label);
          errors.value['table_use'] = true
        }
      }
      if(name === 'type') {
        dataSettingFile.value.type.isError = false;
        dataSettingFile.value.type.error = ''
        errors.value['table_use'] = false
        if(!value) {
          dataSettingFile.value.type.isError = true;
          dataSettingFile.value.type.error = ErrorText.REQUIRED(dataSettingFile.value.type.label);
          errors.value['table_use'] = true
        }
      }
      if(name === 'fields') {
        dataSettingFile.value.fields.isError = false;
        dataSettingFile.value.fields.error = ''
        errors.value['fields'] = false
        if(Object.keys(value).length === 0) {
          dataSettingFile.value.fields.isError = true;
          dataSettingFile.value.fields.error = ErrorText.REQUIRED(dataSettingFile.value.fields.label);
          errors.value['fields'] = true
        }
        if(dataSettingFile.value.table_use.value === 'product' &&
            (!Object.keys(dataSettingFile.value.fields.value).includes('warehouse_code') ||
            !Object.keys(dataSettingFile.value.fields.value).includes('warehouse_id'))
        ) {
          dataSettingFile.value.fields.isError = true;
          dataSettingFile.value.fields.error = ErrorText.INCLUDES('sản phẩm', 'Mã kho hàng, Kho');
          errors.value['fields'] = true
        }
      }
    }

    const checkSubmitActive = computed(() => {
      let error = false;
      for (const err in errors.value) {
        if(errors.value[err]) {
          error = true;
        }
      }
      return !error;
    })

    function prepareFields(fields) {
      let prepareFields = []
      for (const [key, field] of Object.entries(fields)) {
        prepareFields.push({
          field: key,
          name: field
        })
      }
      return prepareFields
    }

    function removeError(key) {
      errorMessage.value.splice(key, 1)
    }

    function getDataSettingFileDetail() {
      const params = {
        company_id: accountStore.account.company.id,
        setting_id: settingId.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/format-file/detail';
      settingFormatFileStore.getSettingFormatFile(url, params);
    }

    return {
      createSettingFile,
      fieldsCustom,
      fields,
      dataSettingFile,
      checkAll,
      errorMessage,
      labelButtonSetting,
      CommonService,
      errors,
      onChange,
      validateForm,
      onChangeSelectItem,
      onChangeSelectAll,
      checkItems,
      removeError,
      checkSubmitActive
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-setting-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
          .fields-custom {
            .content-custom {
              padding: 10px;
              border: 1px solid #d9dee3;
              border-radius: 10px;
              height: 340px;
              overflow-y: scroll;
              transition: color 1s ease;
              &::-webkit-scrollbar {
                width: 5px;
              }
              &::-webkit-scrollbar-track {
                background: #f1f2f4;
              }
              &::-webkit-scrollbar-thumb {
                background:  #dde5fb;
              }
              &::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
              ul {
                li {
                  span {
                    background: #66ccff;
                    padding: 4px 10px;
                    cursor: pointer;
                    border-radius: 5px;
                    color: #ffffff
                  }
                }
              }
            }
          }
          .fields-fixed {
            .content-fixed {
              padding: 10px;
              border: 1px solid #d9dee3;
              border-radius: 10px;
              height: 340px;
              overflow-y: scroll;
              transition: color 1s ease;
              &::-webkit-scrollbar {
                width: 5px;
              }
              &::-webkit-scrollbar-track {
                background: #f1f2f4;
              }
              &::-webkit-scrollbar-thumb {
                background:  #dde5fb;
              }
              &::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
              ul {
                li {
                  cursor: pointer;
                  &:first-child {
                    background: #66ccff;
                    padding: 2px 0 2px 0px;
                    cursor: pointer;
                    border-radius: 5px
                  }
                  &:not(.header):hover {
                    background: #e6f7ff;
                  }
                  .name {
                      background: #66ccff;
                      padding: 2px 10px;
                      cursor: pointer;
                      border-radius: 5px;
                      color: #ffffff
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
